import { RoundTitle } from "@client/components/round/RoundTitle";
import { Button } from "@client/components/utils/Button";
import { Tab, Tabs } from "@client/components/utils/Tabs";
import { getAllProposalForms, getProposalForm } from "@engine/round/accessors";
import { Field, ProposalForm } from "@engine/round/aggregate";
import { generateProposalFieldId } from "@lib/utils/idGeneration";
import { useContext, useState } from "react";
import { DispatchContext, StateContext } from "../Round";

export function ProposalFormPage() {
  const { round } = useContext(StateContext);
  const proposalForms = getAllProposalForms(round);
  const [proposalFormId, setProposalFormId] = useState<string | null>(
    proposalForms[0]?.id,
  );

  const proposalForm =
    proposalFormId == null ? null : getProposalForm(round, proposalFormId);

  return (
    <div className="w-full">
      <RoundTitle />
      <Tabs>
        {proposalForms.map(({ id, name }) => (
          <Tab
            key={id}
            selected={proposalFormId === id}
            onClick={() => setProposalFormId(id)}
          >
            {name}
          </Tab>
        ))}
      </Tabs>
      {proposalForm && <ProposalFormEl form={proposalForm} />}
    </div>
  );
}

function ProposalFormEl({ form }: { form: ProposalForm }) {
  const dispatch = useContext(DispatchContext);

  function addField() {
    const fieldId = generateProposalFieldId();
    const title = `Field ${form.fields.length + 1}`;

    void dispatch({
      type: "ADD_OR_UPDATE_PROPOSAL_FORM_FIELD",
      field: {
        id: fieldId,
        title,
        type: "question",
        source: "appInterface",
        status: "active",
      },
      proposalFormId: form.id,
    });
  }

  return (
    <div className="flex flex-col p-2 max-w-4xl mx-auto">
      <div className="flex flex-col gap-5">
        {form.fields.map((field, idx) => (
          <FormField field={field} key={idx} />
        ))}
      </div>
      <Button onClick={addField}>Add</Button>
    </div>
  );
}

export function FormField({ field }: { field: Field }) {
  return (
    <div>
      <div className="flex flex-row">
        <h2 className={field.type === "question" ? "text-2xl" : "text-4xl"}>
          {field.title}
        </h2>
        {field.status !== "active" && (
          <div className="text-gray-300 text-sm">[{field.status}]</div>
        )}
      </div>
      <p className="text-xs mt-1 mb-2">{field.description}</p>
    </div>
  );
}
